import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Header from '../components/header-no-menu';
import '../../sass/style.scss';

const TemplateWrapperItem = ({ children }) => (
  <div>
    <Helmet
      title="Squidsource | Porfolio"
    />
    <Header />
    {children()}
  </div>
);

TemplateWrapperItem.propTypes = {
  children: PropTypes.func,
};

export default TemplateWrapperItem;



// WEBPACK FOOTER //
// ./src/layouts/portfolio-item.js